import React from 'react';

function NameList({ names, onRemove }) {
  console.log('=== NameList Component ===');
  console.log('Received names:', names);

  // Extrai os nomes do array aninhado se necessário
  const flattenedNames = Array.isArray(names) 
    ? (Array.isArray(names[0]) ? names[0] : names)
    : [];

  console.log('Flattened names:', flattenedNames);

  return (
    <ul style={{ listStyle: 'none', padding: 0 }}>
      {flattenedNames.map((name, index) => (
        <li key={index} style={{ marginBottom: '8px' }}>
          {name} <button onClick={() => onRemove(index)}>Remover</button>
        </li>
      ))}
    </ul>
  );
}

export default NameList;
